import { Controller } from "stimulus"
import selectize from "selectize"

export default class extends Controller {
  static targets = [ "playlistId" ]

  connect() {
    $(this.playlistIdTarget).selectize({
      allowEmptyOption: true,
      highlight: false,
      preload: 'focus',
      load: this.loadPlaylistIdData.bind(this)
    })
  }

  loadPlaylistIdData(value, callback) {
    const user_id = this.data.get("user-id")

    if (user_id) {
      $.ajax({
        url: this.data.get("url").concat(".json"),
        type: "GET",
        data: { q: { user_id, value } },
        success: (data) => {
          callback(data.map(([text, value]) => { return { text, value } }))
        },
        error: callback
      })
    }
  }
}

